import React from 'react';
import PropTypes from 'prop-types';
import {
  AbsoluteContainer,
  Rectangle,
  RelativeContainer,
  Typography,
  Image,
} from '@pitchero/react-ui';
import Icon from '../icon';
import { Trans } from '../../lib/i18n';
import { mapBoxKey } from '../../lib/env';

const Map = ({ name, lat, lng, width, height, zoom, ...otherProps }) => {
  if ((lat === 0 && lng === 0) || lat === null || lng === null) {
    return (
      <RelativeContainer>
        <Rectangle fill="alabaster" component="div" style={{ width: '100%', height: '100%' }}>
          <AbsoluteContainer
            top="50%"
            left={0}
            right={0}
            style={{ textAlign: 'center', marginTop: -50 }}
          >
            <Icon name="location" size={48} color="dustygrey" />
            <Typography preset="name" component="div" color="dustygrey">
              <Trans i18nKey="common:location_not_found">Location not found</Trans>
            </Typography>
          </AbsoluteContainer>
        </Rectangle>
      </RelativeContainer>
    );
  }

  return (
    <a
      href={`https://maps.google.com/maps?z=12&t=m&q=${lat}+${lng}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Image
        alt={name}
        src={`https://api.mapbox.com/styles/v1/mapbox/streets-v11/static/${lng},${lat},${zoom},0,0/${width}x${height}?access_token=${mapBoxKey()}`}
        shimmerOnLoad
        {...otherProps}
      />
    </a>
  );
};

Map.defaultProps = {
  zoom: 16,
  lat: null,
  lng: null,
};

Map.propTypes = {
  height: PropTypes.number.isRequired,
  lat: PropTypes.number,
  lng: PropTypes.number,
  name: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  zoom: PropTypes.number,
};

export default Map;
